module.exports = __webpack_public_path__ + "media/images/coupon/img_empty-1611579f2d29fb517133a551e1797971.svg";